// extracted by mini-css-extract-plugin
export var dividerContainer = "_9x-0";
export var line = "_9x-1";